import { SignupStep } from 'features/signUp/types';

// Zendesk Source Screen names for the signup flow
export const SIGNUP_SOURCE_SCREENS: Record<SignupStep, string> = {
  AccessCodeSubmission: 'access code',
  AccessCodeMatched: 'access code matched',
  UserTypeSelection: 'user type selection',
  ShortCutSSO: 'shortcut your sign up sso',
  ConditionalEligibilityCheck: 'eligibility check',
  DobEligibilityCheck: 'dob eligibility check',
  EligibilityVerified: 'eligibility verified',
  SSOSignUpSuccess: 'SSO sign up success',
  CaregiverProfileCreation: 'caregiver profile creation',
  MemberProfileCreation: 'member profile creation',
  AccountCredentials: 'account credentials',
  PolicyAcceptance: 'policy acceptance',
  Welcome: 'welcome',
  SSOSignupLoading: 'SSO signup loading',
};

/**
 * Returns the progress percentage for a given signup step and user type.
 *
 * The signup flow consists of 11 discrete steps, with the progress bar accepting
 * values between 0-100. Each step increments the progress percentage to visually
 * indicate advancement through the signup process.
 */
export const SIGNUP_STEP_PROGRESS_PRECENTAGE: Record<SignupStep, number> = {
  AccessCodeSubmission: 9,
  AccessCodeMatched: 18,
  UserTypeSelection: 27,
  ShortCutSSO: 36,
  ConditionalEligibilityCheck: 36,
  DobEligibilityCheck: 45,
  EligibilityVerified: 54,
  SSOSignupLoading: 45,
  SSOSignUpSuccess: 54,
  CaregiverProfileCreation: 63,
  MemberProfileCreation: 72,
  AccountCredentials: 81,
  PolicyAcceptance: 90,
  Welcome: 100,
};

export const SIGNUP_ERROR_MESSAGE = {
  GenericVerifyEligibility: 'An unknown error occurred while verifying user eligibility.',
  IneligibleUser: 'User is ineligible.',
  NoNetworkVerifyEligibility: 'No network connection available while verifying user eligibility.',
  UnderageUser: 'User is ineligible due to age restrictions.',
  InvalidAccessCode: 'Access code is invalid.',
  AccessRestricted: 'You are not eligible for the web version of this app',
};

export const MINIMUM_USER_AGE = 13;

export const SIGNUP_SKIP_BROWSER_CONFIRMATION_STEPS: SignupStep[] = ['AccessCodeSubmission'];
